exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-c3a07aba] {\n    color: white !important;\n}\nlabel.btn-success[data-v-c3a07aba] {\n    background-color: #4caf50 !important;\n}\nlabel.btn-warning[data-v-c3a07aba] {\n    background-color: #ff9800 !important;\n}\nlabel.btn-danger[data-v-c3a07aba] {\n    background-color: #f44336 !important;\n}\nlabel.btn-null[data-v-c3a07aba] {\n    background-color: white !important;\n}\n\n", ""]);

// exports
